import { render, staticRenderFns } from "./WizardTemplate.vue?vue&type=template&id=453992ac&"
import script from "./WizardTemplate.vue?vue&type=script&lang=js&"
export * from "./WizardTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports